import { useAppState } from './useAppState';
import { useAppHandlers } from './useAppHandlers';

export function useAppLogic() {
  const state = useAppState();

  const handlers = useAppHandlers({
    selectedDatasets: state.selectedDatasets,
    setSelectedDatasets: state.setSelectedDatasets,
    setSelectedSource: state.setSelectedSource,
    setActiveTab: state.setActiveTab,
    setCorrelations: state.setCorrelations,
    setPreviewDataset: state.setPreviewDataset,
    setFilteredSources: state.setFilteredSources,
    setAppliedTemplate: state.setAppliedTemplate,
    setActiveTutorial: state.setActiveTutorial,
  });

  return {
    ...state,
    ...handlers,
  };
}
